import React from 'react';
export function TablePageShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-13876">
      <span className="sr-only" data-id="element-13877">Loading table…</span>
      {/* Header with button */}
      <div className="flex justify-between items-center" data-id="element-13878">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-13879" />
        <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-13880" />
      </div>
      {/* Stats cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-13881">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-13882">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-13883" />
            <div className="h-8 w-32 bg-gray-200 rounded mb-2" data-id="element-13884" />
            <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-13885" />
          </div>)}
      </div>
      {/* Table */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-13886">
        {/* Table header */}
        <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-13887">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-13888" />
          <div className="h-10 w-64 bg-gray-200 rounded-md" data-id="element-13889" />
        </div>
        {/* Table content */}
        <div className="overflow-x-auto" data-id="element-13890">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-13891">
            <thead data-id="element-13892">
              <tr data-id="element-13893">
                {[1, 2, 3, 4, 5].map(i => <th key={i} className="px-4 py-3" data-id="element-13894">
                    <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-13895" />
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-13896">
              {[1, 2, 3, 4, 5, 6, 7, 8].map(i => <tr key={i} data-id="element-13897">
                  {[1, 2, 3, 4, 5].map(j => <td key={j} className="px-4 py-4" data-id="element-13898">
                      <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-13899" />
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="p-4 border-t border-gray-200 flex justify-between items-center" data-id="element-13900">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-13901" />
          <div className="flex gap-2" data-id="element-13902">
            {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-8 bg-gray-200 rounded" data-id="element-13903" />)}
          </div>
        </div>
      </div>
    </div>;
}